import { render } from "./BlogDetails.vue?vue&type=template&id=0ab96e44&scoped=true&ts=true"
import script from "./BlogDetails.vue?vue&type=script&lang=ts"
export * from "./BlogDetails.vue?vue&type=script&lang=ts"

import "./BlogDetails.vue?vue&type=style&index=0&id=0ab96e44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab96e44"]])

export default __exports__